import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { List, ListLink } from "../themeV2";
import css from "./NavigationSection.module.css";

NavigationSection.displayName = "NavigationSection";
NavigationSection.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      path: PropTypes.string,
      exact: PropTypes.bool,
      href: PropTypes.string,
      icon: PropTypes.node,
      endIcon: PropTypes.node,
    }),
  ).isRequired,
  collapsible: PropTypes.bool,
  onLinkClick: PropTypes.func,
  idx: PropTypes.number.isRequired,
};

const linkComponent = (link) =>
  link.path ? NavLink : link.href ? "a" : "button";

const linkProps = (link) => {
  if (link.path) {
    return {
      to: link.path,
      exact: link.exact,
      activeClassName: ListLink.activeClassName,
    };
  }
  if (link.href) {
    return { href: link.href };
  }
  return {};
};

export default function NavigationSection({ label, links, onLinkClick }) {
  const linkElements = links.map((link) => (
    <ListLink
      key={link.id}
      as={linkComponent(link)}
      leading={link.icon}
      trailing={link.endIcon}
      onClick={onLinkClick}
      className={link.id === "log-out" ? css.signOut : undefined}
      {...linkProps(link)}
    >
      {link.label}
    </ListLink>
  ));

  return (
    <>
      {label && <List.Subheader>{label}</List.Subheader>}
      {linkElements}
    </>
  );
}
